module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("PREFACE")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In the months we spent gathering the prayers for this book, it seemed to us that they organized themselves into an emotional, spiritual, and chronological cycle closely resembling that of a garden transformed by the eternal cycle of the seasons. Thus our title, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Garden of Prayer.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each of the five sections is named for one of the seasons, including a second spring of rebirth. The book opens with the ebulliantly youthful prayers of Spring—full of hope, celebration and yearning. The prayers of Summer are those of the adult in full bloom, immersed in the concerns of family, relationship, and work. Autumn follows with the muted voice of growing maturity that begins to question itself on deeper levels, seeking to better understand the changes life brings. In the prayers of Winter we confront profound issues of identity, the condition of our faith and our mortality. Finally, with the Returning Spring come prayers of renewal. Greater depths of understanding and renewed faith lead us to see our loved ones and friends, our community, our nation, and the entire planet in the clear light of affirmation and caring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is truly a book for each member of the family, honoring each rite of passage, each season of life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were personally inspired by the extraordinary variety of voices that became part of our prayer cycle: St. Francis of Assisi, King David, Robert Louis Stevenson, an anonymous African girl, Thomas Merton and St. Thomas Aquinas, Abraham Lincoln, Dag Hammarskjöld, Teilhard de Chardin, Carmen de Gasztold, Beethoven, an aging medieval woman, Mustafah the tailor, a hermit. Each voice is an integral part of the whole, complementing, harmonizing, and supporting each other in one extended, vibrant expression of celebration and reverence.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("In preparing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Garden of Prayer")]), _vm._v(", we spent a great deal of time reading each section aloud. We suggest you do the same for we discovered that sharing the book in this way is deeply rewarding. Try it in family groups or with friends, each section separately, or, even better, read the entire cycle from beginning to end. The myriad voices, nations, and cultures blend into a melodic whole that we hope will bring with it courage, grace and transcendence.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jenna Bassin and Jane Lahr")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-563e3768","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Preface.vue
// module id = 63
// module chunks = 0